import React from 'react';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import OverloadSection from '../components/landing/OverloadSection';
import About from '../components/landing/About';
import Contact from '../components/landing/Contact';
import Floating3DShapes from '../components/landing/Floating3DShapes';
import AnimatedParticles from '../components/landing/AnimatedParticles';
import '../App.css';
import './Landing.css';

function Landing() {
  return (
    <div className="landing-page">
      <div className="background-grid"></div>
      <div className="gradient-blob gradient-blob-1"></div>
      <div className="gradient-blob gradient-blob-2"></div>
      <div className="gradient-blob gradient-blob-3"></div>
      <div className="scattered-dots">
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
        <div className="scattered-dot"></div>
      </div>

      <Floating3DShapes />
      <AnimatedParticles />

      <div className="landing-page-content">
        <Navbar />
        <Hero />
        <OverloadSection />
        <About />
        <Contact />
      </div>
    </div>
  );
}

export default Landing;
